<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import AvContractListItem from './components/AvContractListItem';
import NewAvContractDialog from './components/NewAvContractDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'AvContractList',
  components: {
    AvContractListItem,
    NewAvContractDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Bezeichnung des AV-Vertrags', value: 'name' },
        { text: 'Organisationseinheit', value: '' },
        { text: 'Fachverantwortlicher für diesen AV-Vertrag', value: '' },
        { text: 'Status', value: '' },
        { text: 'Befragung Status', value: '' },
        { text: 'Aktionen', value: '', sortable: false }],
      showNewAvContractDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      avContractToDelete: {},
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(['avContractList']),
    ...mapState('avContractList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('avContractList', { fetchData: 'fetchAvContractList' }),
    ...mapActions('avContractList', ['deleteAvContract', 'fetchAvContractList']),
    onDelete(avContractToDelete) {
      this.avContractToDelete = avContractToDelete;
      this.confirmDeletionMessage =
        `Soll der AV-Vertrag ${this.avContractToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteAvContract(this.avContractToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
    onSearch() {
      this.paginationParams.searchTerm = this.searchTerm;
      this.fetchData(this.paginationParams);
    },
  },
};
</script>

<template>
  <div class="avContract-list">
    <template v-if="avContractList.hasError">
      <p class="js-error-template ma-3">Failed to fetch avContract list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewAvContractDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Hinzufügen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-spacer />
        <v-flex md3 >
          <v-text-field
            v-model="searchTerm"
            label="Suche"
            height="22"
            class="caption"
            @keyup.enter="onSearch"
            @blur="onSearch"
          />
        </v-flex>
      </v-toolbar>

      <v-progress-linear
        v-if="avContractList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="avContractList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="avContractList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, avContractList.data)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <avContract-list-item
            :av-contract="props.item"
            :expanded="props.expanded"
            @delete="onDelete"
          />
        </template>

        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>

      <NewAvContractDialog
        v-if="showNewAvContractDialog"
        @cancel="showNewAvContractDialog = false"
      />

      <rbx-confirm-dialog
        @confirm="onConfirm" @refuse="onRefuse"
        :message="confirmDeletionMessage"
        :is-displayed="isConfirmDialogDisplayed"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
